import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import {
  classNames,
  transformDateToLocalDateString,
  transformRoute,
} from "helpers";

import VehiclesWidget from "ui/modules/dashboard/pages/DashboardPage/components/VehiclesWidget/VehiclesWidget";
import ExpensesWidget from "ui/modules/dashboard/pages/DashboardPage/components/ExpensesWidget/ExpensesWidget";
import OfferWidget from "ui/modules/dashboard/pages/DashboardPage/components/OfferWidget/OfferWidget";
import AlertsWidget from "ui/modules/dashboard/pages/DashboardPage/components/AlertsWidget/AlertsWidget";
import InvoiceWidget from "ui/modules/dashboard/pages/DashboardPage/components/InvoiceWidget/InvoiceWidget";
import ContractWidget from "ui/modules/dashboard/pages/DashboardPage/components/ContractWidget/ContractWidget";
import OverviewWidget from "ui/modules/dashboard/pages/DashboardPage/components/OverviewWidget/OverviewWidget";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { FleetVehicleRow } from "../fleet/vehicles/types";
import { isNewVehicle } from "../fleet/vehicles/consts";
import { FleetVehicleExpenseRow } from "../fleet/vehicles/expenses/types";
import { FleetVehicleOfferRentRow, FleetVehicleOfferSaleRow } from "../fleet/vehicles/offers/types";
import { InvoiceOutgoingRow, InvoiceRentRow } from "../fleet/vehicles/invoices/types";
import { FleetVehicleContractRentRow, FleetVehicleContractSaleRow } from "../fleet/vehicles/contracts/types";
import { AvailableWidget } from "ui/components/Grid/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import { ButtonLink } from "ui/components/Button/ButtonLink";
import { CopyButton } from "ui/components/Button/CopyButton";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import VehiclesHeaderWidget from "ui/modules/dashboard/pages/DashboardPage/components/VehiclesWidget/components/VehiclesHeaderWidget/VehiclesHeaderWidget";
import { formatCurrency } from "helpers";
import Badge from "ui/components/Badge/Badge";
import Tooltip from "ui/components/Tooltip/Tooltip";
import ContactCell from "ui/components/Table/TableSearch/components/Cells/ContactCell";
import VehicleCell from "ui/components/Table/TableSearch/components/Cells/VehicleCell";
import { PictureIcon } from "ui/components/Pictures";
import { getOfferStatusBadgeVariant } from "services/api/offers/consts";
import { getInvoiceStatusBadgeVariant } from "services/api/invoices/consts";
import { getContractStatusBadgeVariant } from "services/api/contracts/consts";

/*-------------------------------------------------------------------------------------------
  DASHBOARD STATS
---------------------------------------------------------------------------------------------*/

// export const initialLeadStats: LeadStats = {
//   queryNumberCurrent: 0,
//   queryNumberCurrentPercentage: 0,
//   queryNumberRealized: 0,
//   queryNumberRealizedPercentage: 0,
// };

// export const initialOfferStats: OfferStats = {
//   queryNumberCurrent: 0,
//   queryNumberCurrentPercentage: 0,
//   queryNumberRealized: 0,
//   queryNumberRealizedPercentage: 0,
// };

// export const initialFuelStats: FuelStats = {
//   dieselPercentage: 0,
//   petrolPercentage: 0,
//   hybridPercentage: 0,
//   electricPercentage: 0,
// };

// export const initialTotalConsumptionStats: TotalConsumptionStats = {
//   dieselPercentage: 0,
//   petrolPercentage: 0,
//   hybridPercentage: 0,
//   electricPercentage: 0,
// };

// export const initialWeekStats: WeekStats = {
//   mondayCurrentNumber: 0,
//   mondayPreviousNumber: 0,
//   tuesdayCurrentNumber: 0,
//   tuesdayPreviousNumber: 0,
//   wednesdayCurrentNumber: 0,
//   wednesdayPreviousNumber: 0,
//   thursdayCurrentNumber: 0,
//   thursdayPreviousNumber: 0,
//   fridayCurrentNumber: 0,
//   fridayPreviousNumber: 0,
//   saturdayCurrentNumber: 0,
//   saturdayPreviousNumber: 0,
//   sundayCurrentNumber: 0,
//   sundayPreviousNumber: 0,
// };

// export const initialDashboardStats: DashboardStats = {
//   // leadStats: initialLeadStats,
//   offerStats: initialOfferStats,
//   fuelStats: initialFuelStats,
//   totalConsumptionStats: initialTotalConsumptionStats,
//   weekStats: initialWeekStats,
//   reviews: [],
// };

/*-------------------------------------------------------------------------------------------
  DASHBOARD STATS - VEHICLES
---------------------------------------------------------------------------------------------*/


export const DASHBOARD_VEHICLE_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
    {
      title: "",
      key: "image",
      field: "image",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      render: (row: FleetVehicleRow) => {
        return (
          <div
            className={classNames(
              "after:absolute after:-left-0.5 after:-top-0.5 after:bottom-0 after:w-[3px]  after:content-['']",
              isNewVehicle(row.kmTraveled, row.firstRegistrationDate)
                ? "after:bg-red-400"
                : "after:bg-green-400"
            )}
          >
            {row.picture ? (
              <img
                src={row.picture}
                alt=""
                className="h-9 object-cover object-center block"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
                <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  {row.vehicleManufacturer?.name
                    ?.toString()
                    .charAt(0)
                    .toUpperCase()}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.name",
      key: "name",
      field: "",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="">
            <div className="text-md mb-1">{row.name}</div>
            <div className="flex gap-2">
              {row.registrationPlate && (
                <div className="bg-slate-50 text-slate-700 rounded-sm px-2 py-1 text-xs font-medium flex items-center">
                  {t("admin.fleet.vehicle.search.registrationplate")}:{" "}
                  {row.registrationPlate}
                  <CopyButton value={row.registrationPlate} />
                </div>
              )}
              {row.vinNumber && (
                <div className="bg-slate-50 text-slate-700 rounded-sm px-2 py-1 text-xs font-medium flex items-center">
                  {t("admin.fleet.vehicle.search.vin")}: {row.vinNumber}
                  <CopyButton value={row.vinNumber} />
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.manufacturer",
      key: "manufacturer",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleRow) => {
        return (
          <div className="flex items-center gap-2">
            {row.vehicleManufacturer && (
              <img src={row.vehicleManufacturer?.image ?? ""} alt="" className="w-12 flex-shrink-0 rounded-full object-cover" />
            )}
            <div>
              {row.vehicleManufacturer?.name}
            </div>
          </div>);
      },
    },
    {
      title: "admin.fleet.vehicle.search.model",
      key: "model",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleRow) => {
        return (
          <div>
            <div className="text-md">{row.vehicleModel?.name} </div>
            {row.vehicleModel?.year && (
              <div className="text-sm font-normal">
                {t("admin.fleet.vehicle.search.vehiclemodel.year")}:{" "}
                {row.vehicleModel?.year}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.type",
      key: "type",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleRow) => {
        return (
          <div>
            <div className="text-md mb-1">
              {row.vehicleType?.name} {row.vehicleType?.engine} (
              {row.vehicleType?.maximumPowerKw}kw/
              {row.vehicleType?.maximumPowerHp}hp)
            </div>
            <div className="flex gap-2">
              {row.vehicleType?.fuelType && (
                <div className="bg-yellow-100 text-yellow-600 rounded-sm px-2 py-1 text-xs font-medium flex items-center">
                  {t("admin.fleet.vehicle.search.fueltype")}:{" "}
                  {row.vehicleType?.fuelType?.name}
                </div>
              )}
              {row.vehicleType?.transmission && (
                <div className="bg-orange-100 text-orange-600 rounded-sm px-2 py-1 text-xs font-medium flex items-center">
                  {t("admin.fleet.vehicle.search.transmission")}:{" "}
                  {row.vehicleType.transmission.name}
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.currentkm",
      key: "currentKm",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">
            {row.kmTraveled
              ? `${row.kmTraveled.toLocaleString("hr-Hr")} km`
              : "-"}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.firstregistration",
      key: "firstRegistration",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">
            {row.registrationExpiration
              ? `${transformDateToLocalDateString(row.registrationExpiration)}`
              : "-"}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.purchaseprice",
      key: "purchaseprice",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleRow) => {
        return (
          <div className="text-sm">
            <div className="flex justify-between gap-4">
              <span className="text-gray-500">{t("admin.fleet.vehicle.search.netprice")}:</span>
              <span className="font-medium">
                {row.price?.netPrice ? `${row.price.netPrice.toLocaleString("hr-HR")} €` : "-"}
              </span>
            </div>
            <div className="flex justify-between gap-4">
              <span className="text-gray-500">{t("admin.fleet.vehicle.search.specialtax")}:</span>
              <span className="font-medium">
                {row.price?.specialTax ? `${row.price.specialTax.toLocaleString("hr-HR")} €` : "-"}
              </span>
            </div>
            <div className="flex justify-between gap-4 border-t border-gray-200 pt-0.5 mt-0.5">
              <span className="text-gray-500 font-bold">Ukupna nabavna:</span>
              <span className="font-bold text-amber-600">
                {row.price?.totalPurchasePrice ? `${row.price.totalPurchasePrice.toLocaleString("hr-HR")} €` : "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.search.sellingprice",
      key: "sellingPrice",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleRow) => {
        return (
          <div className="text-sm">
            <div className="flex justify-between gap-4">
              <span className="text-gray-500">Popust:</span>
              <span className={row.price?.netDiscount ? "font-medium text-red-500" : "font-medium"}>
                {row.price?.netDiscount ? `-${row.price.netDiscount.toLocaleString("hr-HR")} €` : "-"}
              </span>
            </div>
            <div className="flex justify-between gap-4">
              <span className="text-gray-500">Marža:</span>
              <span className={`font-medium ${row.price?.margin != null && row.price.margin >= 0 ? "text-green-600" : "text-red-600"}`}>
                {row.price?.margin != null ? `${row.price.margin >= 0 ? "+" : ""}${row.price.margin.toLocaleString("hr-HR")} € (${row.price.marginPercentage?.toFixed(1)}%)` : "-"}
              </span>
            </div>
            <div className="flex justify-between gap-4 border-t border-gray-200 pt-0.5 mt-0.5">
              <span className="text-gray-500 font-bold">{t("admin.fleet.vehicle.search.sellingprice")}:</span>
              <span className="font-bold text-green-600">
                {row.price?.sellingPrice ? `${row.price.sellingPrice.toLocaleString("hr-HR")} €` : "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "",
      key: "actions",
      field: "type",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
            <ButtonLink
              startIcon="/media/icons/vehicle.svg"
              cssClassName="text-slate-600 hover:bg-blue-100"
              size="full"
              variant="text"
              to={transformRoute(
                FleetVehicleRoutes.FleetVehicleDetailPageRouter,
                {
                  id: row.id,
                }
              )}
            >
              {t("admin.fleet.vehicle.search.vehicledetail")}
            </ButtonLink>
            <ButtonLink
              startIcon="/media/icons/expense.svg"
              cssClassName="text-slate-600 hover:bg-blue-100"
              size="full"
              variant="text"
              to={transformRoute(
                FleetVehicleRoutes.FleetVehicleExpenseSearchPageRouter,
                {
                  id: row.id,
                }
              )}
            >
              {t("admin.fleet.vehicle.search.vehiclecost")}
            </ButtonLink>
            <ButtonLink
              startIcon="/media/icons/offer.svg"
              cssClassName="text-slate-600 hover:bg-blue-100"
              size="full"
              variant="text"
              to={transformRoute(
                FleetVehicleRoutes.FleetVehicleOfferSearchPageRouter,
                {
                  id: row.id,
                }
              )}
            >
              {t("admin.fleet.vehicle.search.vehicleoffer")}
            </ButtonLink>
            <ButtonLink
              startIcon="/media/icons/invoice.svg"
              cssClassName="text-slate-600 hover:bg-blue-100"
              size="full"
              variant="text"
              to={transformRoute(
                FleetVehicleRoutes.FleetVehicleInvoiceSearchPageRouter,
                {
                  id: row.id,
                }
              )}
            >
              {t("admin.fleet.vehicle.search.vehicleinvoice")}
            </ButtonLink>
            <ButtonLink
              startIcon="/media/icons/contract.svg"
              cssClassName="text-slate-600 hover:bg-blue-100"
              size="full"
              variant="text"
              to={transformRoute(
                FleetVehicleRoutes.FleetVehicleContractSearchPageRouter,
                {
                  id: row.id,
                }
              )}
            >
              {t("admin.fleet.vehicle.search.vehiclecontract")}
            </ButtonLink>
          </ButtonMenu>
        );
      },
    },
  ];


export const DASHBOARD_AVAILABLE_WIDGETS = (
  t: (key: string) => string
): AvailableWidget[] => [
    {
      id: "widget-overview",
      name: t("admin.dashboard.widget.overview.title"),
      description: "Sažetak ključnih pokazatelja flote i poslovanja",
      module: "Pregled",
      icon: "",
      header: <></>,
      component: <OverviewWidget />,
      // Pregled sam nosi mrežu kartica, pa traži najviše mjesta.
      minW: 6,
      minH: 8,
      subWidgets: [
        { id: "overview-total-vehicles", name: "Ukupno vozila", description: "Prikaz broja novih i rabljenih vozila" },
        { id: "overview-registration", name: "Istek registracija", description: "Vozila kojima ističe registracija u narednih 6 mjeseci" },
        { id: "overview-insurance", name: "Istek osiguranja", description: "Vozila kojima ističe osiguranje u narednih 6 mjeseci" },
        { id: "overview-casco", name: "Istek kasko osiguranja", description: "Vozila kojima ističe kasko osiguranje u narednih 6 mjeseci" },
        { id: "overview-fire-extinguisher", name: "Istek vatrogasnih aparata", description: "Aparati kojima istječe rok u narednih 6 mjeseci" },
        { id: "overview-revenue-expense", name: "Prihodi i rashodi", description: "Grafički prikaz prihoda i rashoda za zadnjih 12 mjeseci" },
        { id: "overview-offers", name: "Ponude", description: "Poslane i prihvaćene ponude u zadnjih 6 mjeseci" },
        { id: "overview-invoices", name: "Računi", description: "Izdani i plaćeni računi u zadnjih 6 mjeseci" },
        { id: "overview-inquiries", name: "Upiti", description: "Conversion funnel: upiti → ponude → ugovori" },
      ],
    },
    {
      id: "widget-vehicles",
      name: t("admin.dashboard.widget.vehicles.title"),
      description: "Pretraga i statistika vozila u floti",
      module: "Flota",
      icon: "",
      header: <VehiclesHeaderWidget />,
      component: <VehiclesWidget />,
      // Tablični widgeti — ispod ovoga se stupci i filteri lome.
      minW: 3,
      minH: 6,
    },
    {
      id: "widget-expenses",
      name: t("admin.dashboard.widget.expenses.title"),
      description: "Pregled troškova vozila i analiza po tipovima",
      module: "Financije",
      icon: "",
      header: <></>,
      component: <ExpensesWidget />,
      minW: 3,
      minH: 6,
    },
    {
      id: "widget-offers",
      name: t("admin.dashboard.widget.offers.title"),
      description: "Pretraga i pregled ponuda za vozila",
      module: "Prodaja",
      icon: "",
      header: <></>,
      component: <OfferWidget />,
      minW: 3,
      minH: 6,
    },
    {
      id: "widget-invoices",
      name: t("admin.dashboard.widget.invoices.title"),
      description: "Pretraga i pregled računa za vozila",
      module: "Financije",
      icon: "",
      header: <></>,
      component: <InvoiceWidget />,
      minW: 3,
      minH: 6,
    },
    {
      id: "widget-contracts",
      name: t("admin.dashboard.widget.contracts.title"),
      description: "Pretraga i pregled ugovora o prodaji",
      module: "Prodaja",
      icon: "",
      header: <></>,
      component: <ContractWidget />,
      minW: 3,
      minH: 6,
    },
    {
      id: "widget-alerts",
      name: t("admin.dashboard.widget.alerts.title"),
      description: "Upozorenja o isteku registracija, osiguranja i servisa",
      module: "Flota",
      icon: "",
      header: <></>,
      component: <AlertsWidget />,
      // Popis upozorenja — uži je od tablica, ali treba visinu za nekoliko redaka.
      minW: 3,
      minH: 4,
    },
    // {
    //   id: "widget-invoices",
    //   name: t("admin.dashboard.widget.invoices.title"),
    //   icon: "picture",
    //   header: <>aaa</>,
    //   component: (
    //     <div className="h-full flex items-center justify-center">TODO</div>
    //   ),
    // },

    // {
    //   id: "widget-tires",
    //   name: t("admin.dashboard.widget.tires.title"),
    //   icon: "picture",
    //   header: <>aaa</>,
    //   component: (
    //     <div className="h-full flex items-center justify-center">TODO</div>
    //   ),
    // },
    // {
    //   id: "widget-drivers",
    //   name: t("admin.dashboard.widget.drivers.title"),
    //   icon: "picture",
    //   header: <>aaa</>,
    //   component: <DriversWidget />,
    // },
    // {

    // {
    //   id: "widget-fireextinguishers",
    //   name: t("admin.dashboard.widget.fireextinguishers.title"),
    //   icon: "picture",
    //   header: <>aaa</>,
    //   component: (
    //     <div className="h-full flex items-center justify-center">TODO</div>
    //   ),
    // },

  ];

// export const DASHBOARD_DRIVER_SEARCH_COLUMNS = (
//   t: (key: string) => string
// ): Column[] => [
//     {
//       title: "admin.fleet.vehicle.driver.search.name",
//       field: "",
//       type: ColumnTypes.custom,
//       render: (row: FleetVehicleDriverRow) => {
//         return (
//           <div>
//             <div>
//               <Link
//                 to={transformRoute(
//                   FleetVehicleRoutes.FleetVehicleDriverSearchPageRouter,
//                   {
//                     id: row.vehicle.id,
//                   }
//                 )}
//               >
//                 <div className="text-md">
//                   {row.contact.firstName} {row.contact.lastName}
//                 </div>
//               </Link>
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       title: "admin.fleet.vehicle.driver.search.vehicle",
//       field: "",
//       type: ColumnTypes.custom,
//       render: (row: FleetVehicleDriverRow) => {
//         return (
//           <div>
//             <Link
//               to={transformRoute(
//                 FleetVehicleRoutes.FleetVehicleDetailPageRouter,
//                 {
//                   id: row.vehicle.id,
//                 }
//               )}
//             >
//               <div className="text-md text-[#344054]">
//                 {row.vehicle.vehicleManufacturer.name}{" "}
//                 {row.vehicle.vehicleModel.name} {row.vehicle.vehicleType.name}
//               </div>
//             </Link>
//           </div>
//         );
//       },
//     },
//     {
//       title: "admin.fleet.vehicle.driver.search.driverslicence",
//       field: "",
//       type: ColumnTypes.custom,
//       render: (row: FleetVehicleDriverRow) => {
//         return (
//           <div>
//             <div className="text-md text-[#344054]">
//               {t("admin.fleet.vehicle.driver.search.driverslicencenumber")}:{" "}
//               {row.driversLicenceNumber}
//             </div>
//             <div className="text-sm text-slate-500 truncate">
//               {t("admin.fleet.vehicle.driver.search.driverslicenceexpiry")}:
//               {row.driversLicenceExpiry &&
//                 transformDateToLocalDateString(row.driversLicenceExpiry)}
//             </div>
//           </div>
//         );
//       },
//     },
//   ];

export const DASHBOARD_EXPENSES_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.expense.search.type",
      key: "expense_type",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <Badge
          text={row.expenseTypeName ?? "-"}
          variant="info"
          height="small"
          showDot
        />
      ),
    },
    {
      title: "admin.fleet.vehicle.expense.search.name",
      key: "expense_name",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <div className="font-medium text-slate-900">{row.name}</div>
      ),
    },
    {
      title: "admin.fleet.vehicle.expense.search.description",
      key: "expense_description",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <div className="text-sm text-slate-600 max-w-[800px] overflow-hidden text-ellipsis line-clamp-1">
          {row.description}
        </div>
      ),
    },
    {
      title: "admin.fleet.vehicle.expense.search.expensedate",
      key: "expense_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <div className="text-sm">{transformDateToLocalDateString(row.expenseDate)}</div>
      ),
    },
    {
      title: "admin.fleet.vehicle.expense.search.amount",
      key: "expense_amount",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <Tooltip
          decorate={<span className="text-sm font-medium">{formatCurrency.format(row.amount ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
            <div className="min-w-[220px]">
              <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled iznosa</div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Iznos bez PDV-a</span>
                <span className="font-medium">{formatCurrency.format(row.amount ?? 0)}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">PDV</span>
                <span className="font-medium">{formatCurrency.format(row.taxAmount ?? 0)}</span>
              </div>
              <div className="border-t border-slate-600 my-2"></div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-300">Ukupno</span>
                <span className="font-bold text-green-400">{formatCurrency.format((row.amount ?? 0) + (row.taxAmount ?? 0))}</span>
              </div>
            </div>
          </Tooltip>
      ),
    },
    {
      title: "",
      key: "expense_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e) => onDeleteClick(e, row.id)}
          >
            {t("admin.common.delete")}
          </ButtonMenuItem>
        </ButtonMenu>
      ),
    },
  ];

export const DASHBOARD_OFFER_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string,
    vehicleId: string
  ) => void
): Column[] => [
    {
      title: "",
      key: "offer_pdf",
      field: "",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        if (!row.pdfUpload) return null;
        // Klik otvara generiranu PDF ponudu u novom tabu.
        return (
          <PictureIcon
            url={row.pdfUpload.url}
            fileName={row.pdfUpload.originalFileName}
            tooltip={row.pdfUpload.originalFileName}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.search.offernumber",
      key: "offer_number",
      field: "offerNumber",
      type: ColumnTypes.string,
    },
    {
      title: "Vozilo",
      key: "offer_vehicle",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        return <VehicleCell vehicle={row.vehicle} />;
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.search.client.name",
      key: "offer_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        return (
          <ContactCell
            contact={row.contactClient}
            onClick={(e) => row.contactClient?.id && onContactClick(e, row.contactClient.id)}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.search.status",
      key: "offer_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getOfferStatusBadgeVariant(row.status.id)}
            height="small"
            showDot={true}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.search.offerdate",
      key: "offer_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        return (
          <div>{transformDateToLocalDateString(row.offerDate)}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.search.duedate",
      key: "offer_duedate",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        const dateStr = transformDateToLocalDateString(row.dueDate);
        if (!row.durationDays) return <>{dateStr}</>;
        return (
          <Tooltip decorate={<span>{dateStr}</span>} position="bottom-left" size="medium">
            <div className="min-w-[200px]">
              <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Detalji dospijeća</div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Datum dospijeća</span>
                <span className="font-medium">{dateStr}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-300">Broj dana</span>
                <span className="font-bold text-sky-400">{row.durationDays}</span>
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.search.total",
      key: "offer_total",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => (
        <Tooltip
          decorate={<span className="text-md font-medium">{formatCurrency.format(row.total ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
          <div className="min-w-[240px]">
            <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled iznosa</div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Cijena bez PDV-a</span>
              <span className="font-medium">{formatCurrency.format(row.totalWithoutTax ?? 0)}</span>
            </div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">PDV</span>
              <span className="font-medium">{formatCurrency.format(row.totalTax ?? 0)}</span>
            </div>
            {(row.totalDiscount ?? 0) > 0 && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Popust</span>
                <span className="font-medium text-amber-400">-{formatCurrency.format(row.totalDiscount ?? 0)}</span>
              </div>
            )}
            <div className="border-t border-slate-600 my-2"></div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-300">Ukupno s PDV-om</span>
              <span className="font-bold text-green-400">{formatCurrency.format(row.total ?? 0)}</span>
            </div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Kreirao",
      key: "offer_created_by",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        return (
          <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
        );
      },
    },
    {
      title: "",
      key: "offer_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => onDeleteClick(e, row.id, row.vehicle?.id || "")}
            >
              {t("admin.common.delete")}
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];

export const DASHBOARD_OFFER_RENT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string,
    vehicleId: string
  ) => void
): Column[] => [
    {
      title: "",
      key: "offer_pdf",
      field: "",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        if (!row.pdfUpload) return null;
        // Klik otvara generiranu PDF ponudu u novom tabu.
        return (
          <PictureIcon
            url={row.pdfUpload.url}
            fileName={row.pdfUpload.originalFileName}
            tooltip={row.pdfUpload.originalFileName}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.offernumber",
      key: "offer_number",
      field: "offerNumber",
      type: ColumnTypes.string,
    },
    {
      title: "Vozilo",
      key: "offer_vehicle",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return <VehicleCell vehicle={row.vehicle} />;
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.client.name",
      key: "offer_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return (
          <ContactCell
            contact={row.contactClient}
            onClick={(e) => row.contactClient?.id && onContactClick(e, row.contactClient.id)}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.status",
      key: "offer_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getOfferStatusBadgeVariant(row.status.id)}
            height="small"
            showDot={true}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.offerdate",
      key: "offer_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return (
          <div>{transformDateToLocalDateString(row.offerDate)}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.duration",
      key: "offer_rent_duration",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return (
          <div className="text-sm">
            {row.rentDurationMonths != null ? `${row.rentDurationMonths} mj.` : "-"}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.monthlyprice",
      key: "offer_rent_monthly",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return (
          <div className="text-sm font-medium">
            {row.monthlyPrice != null ? formatCurrency.format(row.monthlyPrice) : "-"}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.search.total",
      key: "offer_total",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => (
        <Tooltip
          decorate={<span className="text-md font-medium">{formatCurrency.format(row.total ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
          <div className="min-w-[240px]">
            <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled iznosa</div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Cijena bez PDV-a</span>
              <span className="font-medium">{formatCurrency.format(row.totalWithoutTax ?? 0)}</span>
            </div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">PDV</span>
              <span className="font-medium">{formatCurrency.format(row.totalTax ?? 0)}</span>
            </div>
            {(row.totalDiscount ?? 0) > 0 && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Popust</span>
                <span className="font-medium text-amber-400">-{formatCurrency.format(row.totalDiscount ?? 0)}</span>
              </div>
            )}
            <div className="border-t border-slate-600 my-2"></div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-300">Ukupno s PDV-om</span>
              <span className="font-bold text-green-400">{formatCurrency.format(row.total ?? 0)}</span>
            </div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Kreirao",
      key: "offer_created_by",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return (
          <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
        );
      },
    },
    {
      title: "",
      key: "offer_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => onDeleteClick(e, row.id, row.vehicle?.id || "")}
            >
              {t("admin.common.delete")}
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];

export const DASHBOARD_INVOICE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string,
    vehicleId: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.invoice.search.invoicenumber",
      key: "invoice_number",
      field: "invoiceNumber",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.invoice.search.client",
      key: "invoice_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => (
        <ContactCell
          contact={row.contactClient}
          onClick={(e) => row.contactClient?.id && onContactClick(e, row.contactClient.id)}
        />
      ),
    },
    {
      title: "admin.fleet.vehicle.invoice.search.status",
      key: "invoice_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getInvoiceStatusBadgeVariant(row.status.id)}
            height="small"
            showDot={true}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.invoice.search.invoicedate",
      key: "invoice_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => (
        <div>{transformDateToLocalDateString(row.invoiceDate)}</div>
      ),
    },
    {
      title: "admin.fleet.vehicle.invoice.search.duedate",
      key: "invoice_duedate",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => {
        const dateStr = transformDateToLocalDateString(row.dueDate);
        if (!row.durationDays) return <>{dateStr}</>;
        return (
          <Tooltip decorate={<span>{dateStr}</span>} position="bottom-left" size="medium">
            <div className="min-w-[200px]">
              <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Detalji dospijeća</div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Datum dospijeća</span>
                <span className="font-medium">{dateStr}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-300">Broj dana</span>
                <span className="font-bold text-sky-400">{row.durationDays}</span>
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.invoice.search.total",
      key: "invoice_total",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => (
        <Tooltip
          decorate={<span className="text-md font-medium">{formatCurrency.format(row.total ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
          <div className="min-w-[220px]">
            <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled računa</div>
            {row.buyerType && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Tip kupca</span>
                <span className="font-medium">{row.buyerType.name}</span>
              </div>
            )}
            {row.taxRate != null && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">PDV</span>
                <span className="font-medium">{row.taxRate}%</span>
              </div>
            )}
            <div className="border-t border-slate-600 my-2"></div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-300">Ukupno</span>
              <span className="font-bold text-green-400">{formatCurrency.format(row.total ?? 0)}</span>
            </div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Kreirao",
      key: "invoice_created_by",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => (
        <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
      ),
    },
    {
      title: "",
      key: "invoice_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceOutgoingRow) => (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e) => onDeleteClick(e, row.id, row.vehicle?.id || "")}
          >
            {t("admin.common.delete")}
          </ButtonMenuItem>
        </ButtonMenu>
      ),
    },
  ];

export const DASHBOARD_INVOICE_RENT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string,
    vehicleId: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.invoice.search.invoicenumber",
      key: "invoice_number",
      field: "invoiceNumber",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.invoice.search.client",
      key: "invoice_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => (
        <ContactCell
          contact={row.contactClient}
          onClick={(e) => row.contactClient?.id && onContactClick(e, row.contactClient.id)}
        />
      ),
    },
    {
      title: "admin.fleet.vehicle.invoice.search.status",
      key: "invoice_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getInvoiceStatusBadgeVariant(row.status.id)}
            height="small"
            showDot={true}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.invoice.search.invoicedate",
      key: "invoice_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => (
        <div>{transformDateToLocalDateString(row.invoiceDate)}</div>
      ),
    },
    {
      title: "admin.fleet.vehicle.invoice.search.duedate",
      key: "invoice_duedate",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => {
        const dateStr = transformDateToLocalDateString(row.dueDate);
        if (!row.durationDays) return <>{dateStr}</>;
        return (
          <Tooltip decorate={<span>{dateStr}</span>} position="bottom-left" size="medium">
            <div className="min-w-[200px]">
              <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Detalji dospijeća</div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Datum dospijeća</span>
                <span className="font-medium">{dateStr}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-300">Broj dana</span>
                <span className="font-bold text-sky-400">{row.durationDays}</span>
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.invoice.search.total",
      key: "invoice_total",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => (
        <Tooltip
          decorate={<span className="text-md font-medium">{formatCurrency.format(row.total ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
          <div className="min-w-[220px]">
            <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled računa</div>
            {row.buyerType && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Tip kupca</span>
                <span className="font-medium">{row.buyerType.name}</span>
              </div>
            )}
            {row.taxRate != null && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">PDV</span>
                <span className="font-medium">{row.taxRate}%</span>
              </div>
            )}
            <div className="border-t border-slate-600 my-2"></div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-300">Ukupno</span>
              <span className="font-bold text-green-400">{formatCurrency.format(row.total ?? 0)}</span>
            </div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Kreirao",
      key: "invoice_created_by",
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => (
        <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
      ),
    },
    {
      title: "",
      key: "invoice_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: InvoiceRentRow) => (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e) => onDeleteClick(e, row.id, row.vehicle?.id || "")}
          >
            {t("admin.common.delete")}
          </ButtonMenuItem>
        </ButtonMenu>
      ),
    },
  ];

export const DASHBOARD_CONTRACT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string,
    vehicleId: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.contract.search.contractnumber",
      key: "contract_number",
      field: "contractNumber",
      type: ColumnTypes.string,
    },
    {
      title: "Vozilo",
      key: "contract_vehicle",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        return <VehicleCell vehicle={row.vehicle} />;
      },
    },
    {
      title: "admin.fleet.vehicle.contract.search.client",
      key: "contract_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        if (row.contactClient) {
          return (
            <ContactCell
              contact={row.contactClient}
              onClick={(e) => row.contactClient?.id && onContactClick(e, row.contactClient.id)}
            />
          );
        }
        return <div className="text-sm">{row.buyerName ?? "-"}</div>;
      },
    },
    {
      title: "admin.fleet.vehicle.contract.search.status",
      key: "contract_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getContractStatusBadgeVariant(row.status.id)}
            height="small"
            showDot={true}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.contract.search.contractdate",
      key: "contract_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => (
        <div>{transformDateToLocalDateString(row.contractDate)}</div>
      ),
    },
    {
      title: "admin.fleet.vehicle.contract.search.sellingprice",
      key: "contract_price",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => (
        <div className="text-md font-medium">
          {row.sellingPrice != null ? formatCurrency.format(row.sellingPrice) : "-"}
        </div>
      ),
    },
    {
      title: "Kreirao",
      key: "contract_created_by",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => (
        <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
      ),
    },
    {
      title: "",
      key: "contract_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e) => onDeleteClick(e, row.id, row.vehicle?.id || row.offerSale?.vehicle?.id || "")}
          >
            {t("admin.common.delete")}
          </ButtonMenuItem>
        </ButtonMenu>
      ),
    },
  ];

export const DASHBOARD_CONTRACT_RENT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string,
    vehicleId: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.contract.search.contractnumber",
      key: "contract_number",
      field: "contractNumber",
      type: ColumnTypes.string,
    },
    {
      title: "Vozilo",
      key: "contract_vehicle",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => {
        return <VehicleCell vehicle={row.vehicle} />;
      },
    },
    {
      title: "admin.fleet.vehicle.contract.search.client",
      key: "contract_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => {
        if (row.contactClient) {
          return (
            <ContactCell
              contact={row.contactClient}
              onClick={(e) => row.contactClient?.id && onContactClick(e, row.contactClient.id)}
            />
          );
        }
        return <div className="text-sm">{row.lesseeName ?? "-"}</div>;
      },
    },
    {
      title: "admin.fleet.vehicle.contract.search.status",
      key: "contract_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getContractStatusBadgeVariant(row.status.id)}
            height="small"
            showDot={true}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.contract.search.contractdate",
      key: "contract_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => (
        <div>{transformDateToLocalDateString(row.contractDate)}</div>
      ),
    },
    {
      title: "admin.fleet.vehicle.contract.search.duration",
      key: "contract_rent_duration",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => (
        <div className="text-sm">
          {row.rentDurationMonths != null ? `${row.rentDurationMonths} mj.` : "-"}
        </div>
      ),
    },
    {
      title: "admin.fleet.vehicle.contract.search.monthlyprice",
      key: "contract_rent_monthly",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => (
        <div className="text-sm font-medium">
          {row.monthlyPrice != null ? formatCurrency.format(row.monthlyPrice) : "-"}
        </div>
      ),
    },
    {
      title: "admin.fleet.vehicle.contract.search.sellingprice",
      key: "contract_price",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => (
        <div className="text-md font-medium">
          {row.sellingPrice != null ? formatCurrency.format(row.sellingPrice) : "-"}
        </div>
      ),
    },
    {
      title: "Kreirao",
      key: "contract_created_by",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => (
        <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
      ),
    },
    {
      title: "",
      key: "contract_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractRentRow) => (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e) => onDeleteClick(e, row.id, row.vehicle?.id || row.offerRent?.vehicle?.id || "")}
          >
            {t("admin.common.delete")}
          </ButtonMenuItem>
        </ButtonMenu>
      ),
    },
  ];
